import * as React from 'react'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import {
  EmptyState,
  EmptyStateFlex,
  EmptyStateIllustrationImage,
} from 'components/EmptyState'
import Button from 'components/Button'
import link from 'infra/link'

export default observer(function JobNotSupported() {
  const history = useHistory()

  const handleBackToCallCenter = () => {
    history.push(link.callCenter())
  }

  return (
    <EmptyStateFlex>
      <EmptyState
        animate
        pad
        title="Not Supported"
        subtitle="This job is not supported"
        image={
          <EmptyStateIllustrationImage
            src={require('assets/images/img_chat-disabled.svg')}
          />
        }
      >
        <Button type="primary" onClick={handleBackToCallCenter}>
          Back to Call Center
        </Button>
      </EmptyState>
    </EmptyStateFlex>
  )
})
